// packages/services/src/dashboardService.ts
import { AdminDashboardStats, ShopDashboardStats, ClientDashboardStats } from '@cabukaka/types';
import axios from 'axios';
import { getConfig } from '@cabukaka/config';


export const dashboardService = {
    getAdminStats: async (token: string): Promise<AdminDashboardStats | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get(`${apiUrl}/dashboard/admin`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    getShopStats: async (token: string): Promise<ShopDashboardStats | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get(`${apiUrl}/dashboard/shop`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    getClientStats: async (token: string): Promise<ClientDashboardStats | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get(`${apiUrl}/dashboard/client`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }
};